<template>
  <div :class="$style.container">
    <form @submit.prevent="login" :class="$style.form">
      <div :class="$style.logo">
        <img src="/icons/common/logo.svg" alt="" />
      </div>
      <div :class="$style.input">
        <input v-model="username" type="text" placeholder="Логин" />
      </div>
      <div :class="$style.input">
        <input v-model="password" :type="passwordType" placeholder="Пароль" />
        <div @click="changePasswordType()">
          <img
            src="/icons/auth/eye.svg"
            alt=""
            v-if="passwordType === 'text'"
          />
          <img
            src="/icons/auth/eye-close.svg"
            alt=""
            v-if="passwordType === 'password'"
          />
        </div>
      </div>

      <div @click="login" :class="$style.button">Войти</div>
      <div v-if="error" :class="$style.error">{{ error }}</div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password",
      error: "",
    };
  },
  methods: {
    async login() {
      if (!this.username || !this.password) {
        return;
      }
      this.error = await this.$store.dispatch("login", {
        username: this.username,
        password: this.password,
      });
    },
    changePasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  .form {
    max-width: 320px;
    width: 100%;
    .logo {
      font-weight: 700;
      font-size: 1.5rem;
      text-align: center;
      margin: 0 0 1.5rem 0;
    }
    .input {
      position: relative;
      margin: 0 0 1rem 0;
      img {
        position: absolute;
        top: 1rem;
        right: 1rem;
        cursor: pointer;
        z-index: 2;
      }
      input {
        font-weight: 400;
        font-size: 1rem;
        width: 100%;
        padding: 1rem;
        outline: 0;
        border: none;
        border-radius: 0.5rem;

        &::placeholder {
          color: $t-secondary;
          font-size: 0.875rem;
        }
      }
      &:last-child {
        margin: 0 0 1.5rem 0;
      }
    }
    .button {
      font-weight: 700;
      background-color: $black;
      padding: 0.75rem;
      text-align: center;
      color: $t-white;
      border-radius: 0.5rem;
      cursor: pointer;
    }
    .error {
      color: $red;
      font-size: 0.875rem;
      margin: 0.5rem 0 0 0;
      text-align: center;
    }
  }
}
</style>
